import { LoginContext } from '@shared/lib/models/login-context';
import { LoginContextProvider } from '@shared/lib/providers/login-context.provider';
import { UsanaLoggingService } from '@usana/ux/common/logging';
import { LoginTokens } from '@usana/ux/sso-auth';
import { miniProgram } from 'weixin-js-sdk';

/**
 * MOCK USING
 * yeah you don't
 *
 */
export class WechatMiniLoginContextProvider extends LoginContextProvider {
  private isMiniProgram;

  constructor() {
    super(true, LoginContext.WECHAT_MINI);

    UsanaLoggingService.logMsg('determining if we are wechat-mini-program', true);
    miniProgram.getEnv((res) => {
      this.isMiniProgram = res.miniprogram;
      UsanaLoggingService.logMsg(`result of mini program is ${this.isMiniProgram}`, true);
    });
  }

  isProvided(window: Window): boolean {
    return this.isMiniProgram;
  }

  notifyOfLogin(window: Window, tokens: LoginTokens, redirectUri: string): void {
    miniProgram.postMessage({
      data: {
        token: tokens.coreToken,
        'id-token': tokens.idToken,
        'refresh-token': tokens.refreshToken,
      },
    });
    miniProgram.navigateBack({
      success: () => {
        // yay
      },
      fail: (e) => {
        console.log('back fail...', e);
      },
    });
  }

  handleExternalRedirect(window: Window, url: string): void {
    miniProgram.navigateTo({
      url: url,
    });
  }
}
